import { CountryState } from "models";

export class Country {
	id: number;
	name: string;
	iso: string;
	iso3: string;
	numCode: string;
	phoneCode: string;
	preferredCurrencyName: string;
	preferredCurrencyIsoCode: string;
	states?: CountryState[];
}
